import { render, staticRenderFns } from "./agentWhiterList.vue?vue&type=template&id=2b11fc9d&scoped=true&"
import script from "./agentWhiterList.vue?vue&type=script&lang=js&"
export * from "./agentWhiterList.vue?vue&type=script&lang=js&"
import style0 from "./agentWhiterList.vue?vue&type=style&index=0&id=2b11fc9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11fc9d",
  null
  
)

export default component.exports